import { render, staticRenderFns } from "./processAccidentRegisterInfo.vue?vue&type=template&id=1fee7cba"
import script from "./processAccidentRegisterInfo.vue?vue&type=script&lang=js"
export * from "./processAccidentRegisterInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fee7cba')) {
      api.createRecord('1fee7cba', component.options)
    } else {
      api.reload('1fee7cba', component.options)
    }
    module.hot.accept("./processAccidentRegisterInfo.vue?vue&type=template&id=1fee7cba", function () {
      api.rerender('1fee7cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/reg/processAccidentRegisterInfo.vue"
export default component.exports